const PUNCHOUT_PENDING_REDIRECT_KEY = 'punchout-pending-redirect';
export const PUNCHOUT_EXTERNAL_REDIRECT_DELAY_MS = 3000;

interface PunchoutPendingRedirect {
  catalogId: number;
  redirectUrl: string;
  showPunchoutOrderGuide?: boolean;
}

const readPunchoutPendingRedirect = (): PunchoutPendingRedirect | null => {
  try {
    const raw = sessionStorage.getItem(PUNCHOUT_PENDING_REDIRECT_KEY);
    if (!raw) {
      return null;
    }

    return JSON.parse(raw) as PunchoutPendingRedirect;
  } catch {
    return null;
  }
};

export const setPunchoutPendingRedirect = (
  catalogId: number,
  redirectUrl: string,
  showPunchoutOrderGuide = true
) => {
  const payload: PunchoutPendingRedirect = {
    catalogId,
    redirectUrl,
    showPunchoutOrderGuide,
  };
  sessionStorage.setItem(PUNCHOUT_PENDING_REDIRECT_KEY, JSON.stringify(payload));
};

export const getPunchoutPendingRedirect = (catalogId: number): string | null => {
  const parsed = readPunchoutPendingRedirect();
  return parsed?.catalogId === catalogId ? parsed.redirectUrl : null;
};

export const shouldShowPunchoutSessionInfo = (catalogId: number): boolean => {
  const parsed = readPunchoutPendingRedirect();
  return parsed?.catalogId === catalogId && parsed.showPunchoutOrderGuide === false;
};

export const clearPunchoutPendingRedirect = () => {
  sessionStorage.removeItem(PUNCHOUT_PENDING_REDIRECT_KEY);
};
